// Filename: public/customSignUpLogin.js

import { session } from 'wix-storage-frontend';
import { setContactLabel } from 'backend/userContact';
import { saveCleverTapEvent } from 'public/cleverTapEvents.js';
import wixWindowFrontend from 'wix-window-frontend';
import { authentication, currentMember } from 'wix-members-frontend';
import { orders } from 'wix-pricing-plans';
import { local } from "wix-storage-frontend";
import { checkAndUpdateSelectedGoals } from 'public/wellBeingGoals.js';
import { assignStoredLabelToUser } from 'public/quizLabelManager';

let authResult;
let referrer = wixWindowFrontend.referrer;

export async function customLoginOrSignup(mode) {
    return new Promise((resolve, reject) => {
        authentication.promptLogin({ mode: mode, modal: true, })
            .then((result) => {
                let resultObj = Object(result);
                console.log('result......', resultObj.revision);
                if (resultObj.revision == 0) {
                    authResult = 'signup';
                } else {
                    authResult = 'login';
                }
                resolve(authResult);
            })
            .catch((error) => {
                reject(error);
                console.error(`${mode === 'signup' ? 'Signup' : 'Login'} failed:`, error);
            });
    });
}

export async function handleLoginSignupCTEvents() {
    let ctLoggedinWith = session.getItem("ctLoggedinWith") ?? "";

    if (ctLoggedinWith) {
        const currentMemberData = await currentMember.getMember();
        console.log('currentMemberData...', currentMemberData);

        await createCTProfile(ctLoggedinWith, currentMemberData);

        const createdTime = new Date(currentMemberData._createdDate).getTime()
        const createdBeforeSec = Math.floor((Date.now() - createdTime) / 1000);
        console.log(`User was created befor ${createdBeforeSec} seconds`);

        if (createdBeforeSec < 60) {
            console.log("Member signed up successfully...");
            sendCTSignupEvent(ctLoggedinWith, currentMemberData);
        } else {
            console.log("Member logged in successfully...");
        }

        setTimeout(() => {
            session.removeItem("ctLoggedinWith");
        }, 15000)
    }

}

async function sendCTSignupEvent(ctLoggedinWith, currentMemberData) {

    /*const currentUserData = await getCurrentMemberEmailAndData();
    console.log('currentUserData...', currentUserData);*/

    let propertiesForCTSignUp = {
        "MarketingSourceAttribution": referrer,
        "WixUserId": currentMemberData._id,
        "Email": currentMemberData.loginEmail,
        "SubscribedToNewsletter": session.getItem("isSubscribedToNewsletter") ?? '',
    };
    propertiesForCTSignUp[`${ctLoggedinWith}`] = true;
    propertiesForCTSignUp.UtmSource = session.getItem("utmSource") ?? "unknown";
    propertiesForCTSignUp.UtmMedium = session.getItem("utmMedium") ?? "unknown";
    propertiesForCTSignUp.UtmCampaign = session.getItem("utmCampaign") ?? "unknown";
    saveCleverTapEvent("User Signed up", propertiesForCTSignUp);

    const originLabels = {
        'LoginWithGmail': 'origingoogle',
        'LoginWithFacebook': 'originfacebook'
    };

    const originLabel = originLabels[ctLoggedinWith];

    if (originLabel) {
        assignLabel(currentMemberData._id, originLabel);
    }

    if (session.getItem("isSubscribedToNewsletter") == 'true') {
        assignLabel(currentMemberData._id, 'subscriber');
        let propertiesForCTSubscribe = { "MSG-email": true };
        propertiesForCTSubscribe["SubscribedToNewsletter"] = true;
        saveCleverTapEvent('profile', propertiesForCTSubscribe);
        if (originLabel) {
            console.log('logging with SSO and checkbox is checked....');
            hiddenSubscribeToNewsletter(currentMemberData.loginEmail);
        }
    }
}

function assignLabel(currentUserDataID, labelName) {
    setContactLabel(currentUserDataID, [`custom.${labelName}`])
        .then((data) => {
            console.log(`Label "${labelName}" added...`);
        })
        .catch((err) => {
            console.log(`Label "${labelName}" failed...`, err);
        })
}

async function createCTProfile(loginSignup, currentMemberData) {

    /*const currentUserData = await getCurrentMemberEmailAndData();
    console.log('currentUserData...', currentUserData);*/

    let listOfOrders = await getOrdersList();
    console.log('listOfOrders...', listOfOrders);

    let propertiesForCT = {
        "name": currentMemberData.profile.nickname,
        "firstName": currentMemberData.contactDetails.firstName,
        "lastName": currentMemberData.contactDetails.lastName,
        "Identity": currentMemberData._id,
        "Email": currentMemberData.loginEmail,
        //"Free Member": "ACTIVE",
    };

    if (listOfOrders.length === 0) {
        console.log('listOfOrders empty...');
        propertiesForCT['Free Member'] = "ACTIVE"
    }

    listOfOrders.forEach((plan) => {
        if (!['Donation', 'App Paid Membership', 'App Lifetime Membership'].includes(plan.planName) && !plan.cancellation) {
            propertiesForCT[plan.planName] = plan.status
        }
    })

    if (loginSignup == 'SignupWithEmail') {
        propertiesForCT['SubscribedToNewsletter'] = session.getItem("isSubscribedToNewsletter") ?? "";
    }
    propertiesForCT[`${loginSignup}`] = true;

    console.log('propertiesForCT...', propertiesForCT);
    saveCleverTapEvent('onUserLogin', propertiesForCT);

    // For Well-Being goals Starts--
    const checkSelectedGoalsFromSession = local.getItem("wellBeingGoals");
    if (checkSelectedGoalsFromSession) {
        await checkAndUpdateSelectedGoals(currentMemberData._id, checkSelectedGoalsFromSession);
    }
    // For Well-Being goals Ends--

    await assignStoredLabelToUser(currentMemberData); // For Quiz Taken Label

}

async function getOrdersList() {
    return new Promise((resolve) => {
        orders.listCurrentMemberOrders({ 'orderStatuses': ['ACTIVE'] })
            .then((ordersList) => {
                if (ordersList && ordersList.length > 0) {
                    resolve(ordersList);
                } else {
                    resolve([])
                }
            })
            .catch((error) => {
                console.log(error);
            });
    })
}

async function hiddenSubscribeToNewsletter(email) {
    $w("#hiddenNewsletterForm").setFieldValues({
        'email_443e': email
    });
    const formValues = await $w("#hiddenNewsletterForm").submit();
    console.log("Form is submitted with the following values", formValues);
}

/*export async function customLoginOrSignup(mode) {
    return new Promise((resolve, reject) => {
        authentication.promptLogin({ mode: mode, modal: true, })
            .then((result) => {
                let ctLoggedinWith = session.getItem("ctLoggedinWith") ?? "";
                createCTProfile(ctLoggedinWith);
                let resultObj = Object(result);
                console.log('result......', resultObj.revision);
                if (resultObj.revision == 0) {
                    console.log("Member signed up successfully...");
                    sendCTSignupEvent(ctLoggedinWith);
                    authResult = 'signup';
                } else {
                    console.log("Member logged in successfully...");
                    authResult = 'login';
                }
                resolve(authResult);
            })
            .catch((error) => {
                reject(error);
                console.error(`${mode === 'signup' ? 'Signup' : 'Login'} failed:`, error);
                //reject(error);
                // if (wixLocationFrontend.prefix == 'assessments') {
                //     customLoginOrSignup('signup')
                // }
            });
    });
}

async function getCurrentMemberEmailAndData() {
    const user = wixUsers.currentUser;
    let userEmail = await user.getEmail();
    const currentUserData = await getMemberDetailByEmail(userEmail);
    return currentUserData;
}

async function getMemberDetailByEmail(email) {
    return new Promise((resolve) => {
        wixData.query("Members/PrivateMembersData")
            .eq('loginEmail', email)
            .find()
            .then(async (results) => {
                if (results.items.length > 0) {
                    resolve(results.items[0]);
                } else {
                    console.log("User isn't a site member:-");
                    resolve(null);
                }
            })
            .catch((err) => {
                console.log("found case error : ", err);
            });
    });
}*/

/*export function customSignup() {
    console.log('Signup popup....');
    authentication.promptLogin({ mode: 'signup', modal: true, })
        .then((result) => {
            let resultObj = Object(result);
            console.log('result......', resultObj.revision);
            if (resultObj.revision == 0) {
                console.log("Member signed up successfully...");
                createCTProfile('SignupWithEmail');
                sendCTSignupEvent();
            } else {
                console.log("User logged in successfully...");
                createCTProfile('LoginWithEmail');
            }
        })
        .catch((error) => {
            console.error('Signup failed:...', error);
        });
}

export function customLogin() {
    console.log('Login popup....');
    authentication.promptLogin({ mode: 'login', modal: true, })
        .then((result) => {
            let resultObj = Object(result);
            console.log('result......', resultObj.revision);
            if (resultObj.revision == 0) {
                console.log("Member signed up successfully...");
                createCTProfile('SignupWithEmail');
                sendCTSignupEvent();
            } else {
                console.log("User logged in successfully...");
                createCTProfile('LoginWithEmail');
            }
        })
        .catch((error) => {
            console.error('Login failed:...', error);
        });
}*/